module.exports = __webpack_public_path__ + "img/performance-4.f90a6367.png";